/**
 * Gate for every /admin route except the login screen.
 *
 * This only controls what renders. The real enforcement is in firestore.rules —
 * bypassing this component would yield a panel whose every read and write is
 * rejected by the server.
 */
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export default function ProtectedRoute({ children }) {
    const { user, isAdmin, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-cs-offwhite">
                <div className="flex items-center gap-3 text-cs-charcoal/70">
                    <Loader2 className="h-5 w-5 animate-spin" />
                    <span className="font-mono text-sm uppercase tracking-wider">
                        Checking access
                    </span>
                </div>
            </div>
        );
    }

    // Remember where they were headed so login can return them there.
    if (!user || !isAdmin) {
        return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
    }

    return children;
}
